<template>
  <div>
      <p>v.2.0</p>
    <v-form ref="refMain">
      <v-container class="px-3 py-0" fluid>
        <v-row fluid>
          <v-col cols="12" sm="2" md="1" lg="1" class="pa-0">
            <v-autocomplete v-model="dSearch.idLocal" label="* Sede"
                            :items="dLocales"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="2" lg="2" class="pa-0">
            <v-autocomplete v-model="dSearch.idServicio" label="* Servicio"
                            :items="dServicios" item-text="Descripcion" item-value="IdServicio"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="2" lg="1" class="pa-0">
            <v-autocomplete v-model="dPeriodo" label="* Periodo"
                            :items="dMatPeriodos"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="2" lg="2" class="pa-0">
            <v-autocomplete v-model="dSearch.tipoActa" label="* Tipo de Acta"
                            :items="dTipoActa"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="1" md="1" lg="1" class="pa-0">
            <v-btn @click.prevent="fuSearch" :loading="dTable.loading" color="primary" dark x-large style="border-radius: 0;"><v-icon>search</v-icon> Buscar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-card>
      <v-data-table
          v-model="dTable.selected"
          :headers="dTable.headers"
          :items="dItems"
          :loading="dTable.loading"
          :search="dTable.search"
          item-key="IdSeccion"
          show-select
          class="elevation-1">
        <template v-slot:item.data-table-select="{ item, isSelected, select }">
          <v-checkbox :input-value="isSelected" :disabled="item.disabled" @change="select($event)"></v-checkbox>
        </template>
        <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
        <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
        <template v-slot:[`item.Seccion`]="{ item }">
          <span>{{item.SiglaCodigoAlumno+item.Nivel+item.Seccion}}</span>
        </template>
      </v-data-table>
    </v-card>
    <v-divider></v-divider>
    <div v-if="this.dItems.length > 0" class="pa-3 blue-grey darken-2">
      <v-btn @click.prevent="fuSave" :loading="dIsUpdating" color="primary"><v-icon left>autorenew</v-icon> Generar Selecionados</v-btn>
      <v-btn @click.prevent="fuSaveAll" :loading="dIsUpdating" color="secondary"><v-icon left>autorenew</v-icon> Generar Todo</v-btn>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag"
import Swal from 'sweetalert2/dist/sweetalert2.js'
import alumno from "../../views/Academico/Alumno"

const clone = obj => JSON.parse(JSON.stringify(obj));

export default {
  data: () => ({
    dPeriodo: '',
    dSearch: {
      anio: '',
      periodo: '',
      idLocal: '',
      idServicio: '',
      tipoActa: ''
    },
    dRomanos: ['I','II','III','IV','V','VI','VII','VIII','IX'],
    disabledCount: 0,
    dLocales: [{ text: 'Centenario', value: 1, tope: 30 }, { text: 'Manantiales', value: 2, tope: 35  }, { text: 'San Sebastian', value: 5, tope: 40  } ],
    dTipoMatricula: ['REGULAR', 'DIRIGIDO', 'POR CURSO'],
    dTipoActa: [{ text: 'Matricula', value: 'MA' }, { text: 'Notas', value: 'AR' }, { text: 'Convalidación', value: 'AC' }, { text: 'Extraordinaria', value: 'AE' }],
    dServicios: [],
    dMatPeriodos: [],
    dIsUpdating: false,
    dTable: {
      headers: [
        {value: 'IdSeccion', text: 'IdSeccion', align: ' d-none'},
        {value: 'Servicio', text: 'Servicio'},
        {value: 'Seccion', text: 'Seccion'},
        {value: 'Matriculados', text: 'Matriculados'},
        {value: 'Enviados', text: 'Enviados'},
      ],
      loading: false,
      search: null,
      selected: []
    },
    dItems: [],
    dItemsAlumno: []
  }),
  mounted(){

  },
  watch: {
    'dSearch.idLocal': function (val) {
      this.fuServicios();
    },
    'dSearch.idServicio': function (val) {
      this.fuPeriodos();
    }
  },
  methods: {
    async fuPeriodos(){
      const response = await this.$apollo.query({
        query: gql`query ($idServicio: Int!) {
          periodosByServicio(IdServicio: $idServicio){
            Anio, Periodo
          }
        }`,
        variables: {
          idServicio: this.dSearch.idServicio
        }
      })

      this.dMatPeriodos = response.data.periodosByServicio.map(item => {
        return item.Anio + '-' + item.Periodo
      })
    },

    async fuServicios(){
      const response = await this.$apollo.query({
        query: gql`query ($idLocal: Int!) {
          PriServicioByLocal(IdLocal: $idLocal) {
             IdServicio,
             Descripcion,
             Iniciales
           }
        }`,
        variables: {
          idLocal: this.dSearch.idLocal
        }
      })

      this.dServicios = response.data.PriServicioByLocal;
    },

    fuSearch(){
      if(!this.$refs.refMain.validate()){
        this.dSnackbar = true
      } else {
        this.fuEnvioMinedu()
      }
    },

    fChunckArray(arr, size) {
      let chunk = [], i;
      for (i = 0; i <= arr.length; i+= size)
        chunk.push(arr.slice(i, i + size));
      return chunk;
    },

    fGenerarJson(items, local){
      let data = [], secciones = [], matriculas = [], notas = []

      const self = this
      items.forEach(item => {
        /*if (item.Enviados === item.Matriculados) {
          return;
        }*/

        let newSeccion = {
          'tipo_acta': self.dSearch.tipoActa,
          'nombre_periodo_lectivo': self.dPeriodo,
          'codigo_modular': item.CodigoModular,
          'nombre_sede_institucion': 'SEDE ' + local.text.toUpperCase(),
          'nivel_formacion': item.NivelFormacion,
          'nombre_carrera': item.Servicio,
          'nombre_plan_estudio': item.Curricula,
          'semestre_academico': self.dRomanos[item.Nivel - 1],
          'turno': item.Turno === 'M' ? 'MAÑANA' : item.Turno === 'T' ? 'TARDE' : 'NOCHE',
          'seccion': `${item.Seccion}`,
          'cantidad_alumno': 0,
          'persona': []
        }

        let seccion = self.dItemsAlumno.find(el => el.IdSeccion === item.IdSeccion && el.IdItinerario === item.IdItinerario)
        newSeccion.cantidad_alumno = seccion.Alumnos.length

        seccion.Alumnos.forEach(alumno => {
          if (alumno.Cursos.length < 1) return;

          let newAlumno = {
            'tipo_documento': alumno.TipoDoc,
            'numero_documento': alumno.Doc,
            'nombre_completo': alumno.Alumno,
            'sexo': alumno.Sexo,
            'edad': alumno.Edad,
            'tiene_discapacidad': false,
            'unidad_didactica': []
          }

          alumno.Cursos.forEach(curso => {
            notas.push(curso.IdNotaFinal)
            newAlumno.unidad_didactica.push({ 'nombre_unidad_didactica': curso.Curso, 'nota': curso.Nota });
          });

          matriculas.push(alumno.IdMatricula);
          newSeccion.persona.push(newAlumno);
        })

        if (item.Modalidad === 'Virtual' || newSeccion.cantidad_alumno <= local.tope) {
          data.push(newSeccion)
        } else {
          const chunks = self.fChunckArray(newSeccion.persona, local.tope);
          chunks.forEach((chunk, index) => {
            const chunkSeccion = clone(newSeccion)
            if (index !== 0) {
              chunkSeccion.seccion = chunkSeccion.seccion + index
            }
            chunkSeccion.cantidad_alumno = chunk.length;
            chunkSeccion.persona = chunk;
            data.push(chunkSeccion)
          })
        }

        secciones.push(item.IdSeccion)
      })

      if (data.length > 40) {
        data = self.fChunckArray(data, 40);
      }

      let json = {
        secciones,
        matriculas,
        notas,
        data
      }

      return json
    },

    fGenerarJsonNotas(items, local) {
      let data = [], secciones = [], matriculas = [], notas = []
      const self = this

      items.forEach(item => {
        if (item.Enviados === item.Matriculados) {
          return;
        }

        let newSeccion = {
          'tipo_acta': self.dSearch.tipoActa,
          'nombre_periodo_lectivo': self.dPeriodo,
          'codigo_modular': item.CodigoModular,
          'nombre_sede_institucion': 'SEDE ' + local.text.toUpperCase(),
          'nivel_formacion': item.NivelFormacion,
          'nombre_carrera': item.Servicio,
          'nombre_plan_estudio': item.Curricula,
          'semestre_academico': self.dRomanos[item.Nivel - 1],
          'turno': item.Turno === 'M' ? 'MAÑANA' : item.Turno === 'T' ? 'TARDE' : 'NOCHE',
          'seccion': '',
          'cantidad_alumno': 0,
          'persona': []
        }

        let nSecciones = self.dItemsAlumno.filter(el => el.IdSeccion === item.IdSeccion && el.IdItinerario === item.IdItinerario)
        nSecciones.forEach(seccion => {

          newSeccion = clone(newSeccion);
          newSeccion.persona = []
          newSeccion.seccion = seccion.SeccionEnviado
          newSeccion.cantidad_alumno = seccion.Alumnos.length

          seccion.Alumnos.forEach(alumno => {
            if (alumno.Cursos.length < 1) return;

            let newAlumno = {
              'tipo_documento': alumno.TipoDoc,
              'numero_documento': alumno.Doc,
              'nombre_completo': alumno.Alumno,
              'sexo': alumno.Sexo,
              'edad': alumno.Edad,
              'tiene_discapacidad': false,
              'unidad_didactica': []
            }

            alumno.Cursos.forEach(curso => {
              notas.push(curso.IdNotaFinal)
              newAlumno.unidad_didactica.push({ 'nombre_unidad_didactica': curso.Curso, 'nota': curso.Nota });
            });

            matriculas.push(alumno.IdMatricula);
            newSeccion.persona.push(newAlumno);
          })

          data.push(newSeccion)
        })

        secciones.push(item.IdSeccion)
      })

      const max = self.dSearch.tipoActa === 'AR' ? 25 : 40

      if (data.length > max) {
        data = self.fChunckArray(data, max)
      }

      let json = {
        secciones,
        matriculas,
        notas,
        data
      }

      return json
    },

    calcularEdad(fecha) {
      let hoy = new Date()
      let cumpleanos = new Date(fecha)
      let edad = hoy.getFullYear() - cumpleanos.getFullYear()
      let m = hoy.getMonth() - cumpleanos.getMonth()

      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--
      }
      return edad
    },

    async fuSave() {
      if(this.dTable.selected.length===0){
        Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
      } else {
        const local = this.dLocales.find(el => el.value === this.dSearch.idLocal)
        let json = this.dSearch.tipoActa === 'AR' ?  this.fGenerarJsonNotas(this.dTable.selected, local) : this.fGenerarJson(this.dTable.selected, local)

        const servicio = this.dServicios.find(el => el.IdServicio === this.dSearch.idServicio)
        try {
          const response = await this.$apollo.mutate({
            mutation: gql`mutation enviar($input: generarJsonMinedu!){
              generarJsonMinedu(input: $input){
                codError, message
              }
            }`,
            variables: {
              input: {
                json: JSON.stringify(json),
                tipoActa: this.dSearch.tipoActa,
                sede: local.text,
                periodo: this.dPeriodo,
                servicio: servicio.Iniciales.toLowerCase()
              }
            }
          })
          const codError = response.data.generarJsonMinedu.codError;
          const message = response.data.generarJsonMinedu.message;

          if (codError === 0) {
            Swal.fire('CORRECTO', message, 'success')
            this.dItems = []
            this.dItemsAlumno = []
          } else {
            console.log(error)
            Swal.fire('¡ ERROR !', 'Error de conexión.', 'error')
          }
        } catch (error) {
          console.log(error)
          Swal.fire('¡ ERROR !', 'Error de conexión.', 'error')
        }
      }
    },

    async fuSaveAll() {
      const local = this.dLocales.find(el => el.value === this.dSearch.idLocal)

      let json = this.dSearch.tipoActa === 'AR' ?  this.fGenerarJsonNotas(this.dItems, local) : this.fGenerarJson(this.dItems, local)
      const servicio = this.dServicios.find(el => el.IdServicio === this.dSearch.idServicio)

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`mutation enviar($input: generarJsonMinedu!){
            generarJsonMinedu(input: $input){
              codError, message
            }
          }`,
          variables: {
            input: {
              json: JSON.stringify(json),
              tipoActa: this.dSearch.tipoActa,
              sede: local.text,
              periodo: this.dPeriodo,
              servicio: servicio.Iniciales.toLowerCase()
            }
          }
        })

        const codError = response.data.generarJsonMinedu.codError;
        const message = response.data.generarJsonMinedu.message;

        if (codError === 0) {
          Swal.fire('CORRECTO', message, 'success')
          this.dItems = []
          this.dItemsAlumno = []
        } else {
          console.log(error)
          Swal.fire('¡ ERROR !', 'Error de conexión.', 'error')
        }

      } catch (error) {
        console.log(error)
        Swal.fire('¡ ERROR !', 'Error de conexión.', 'error')
      }
    },

    async fuEnvioMinedu() {
      this.dTable.loading = true
      const periodo = this.dPeriodo.split('-')
      this.dSearch.anio = periodo[0]
      this.dSearch.periodo = periodo[1]
      this.disabledCount = 0

      try {
        const response = await this.$apollo.query({
          query: gql`query listar($anio: Int!, $periodo: Int!, $idLocal: Int!, $idServicio: Int!, $tipoActa: String!){
            envioMinedu(anio: $anio, periodo: $periodo, idLocal: $idLocal, idServicio: $idServicio, tipoActa:$tipoActa){
              secciones {
                IdSeccion, IdServicio, Iniciales, Servicio, SiglaCodigoAlumno, NivelFormacion, CodigoModular, Seccion, Turno, Nivel, Modalidad, Curricula, IdItinerario, Matriculados, Enviados
              },
              matriculas {
                IdMatricula, IdSeccion, IdCursoCurricula, IdNotaFinal, Alumno, DNI, FechaNac, Sexo, Curso, Curricula, IdItinerario, EnviadoMinedu, EnviadoNotaMinedu, tipo_documento, SeccionEnviado, PromedioFinal
              }
            }
          }`,
          variables: this.dSearch
        })

        this.dItems = []
        this.dItems = response.data.envioMinedu.secciones.map(item => {
          if (item.Enviados === item.Matriculados) {
            item.disabled = true
            item.isSelectable = false
            this.disabledCount++
          }
          return item
        })

        const self = this
        const matriculas = []

        response.data.envioMinedu.matriculas.forEach(item => {
          let index = self.dSearch.tipoActa === 'AR' ?
              matriculas.findIndex(se => se.IdSeccion === item.IdSeccion && se.IdItinerario === item.IdItinerario && se.SeccionEnviado === item.SeccionEnviado.trim()) :
              matriculas.findIndex(se => se.IdSeccion === item.IdSeccion && se.IdItinerario === item.IdItinerario)

          if (index === -1) {
            let newSeccion = self.dSearch.tipoActa === 'AR' ?
                {IdSeccion: item.IdSeccion, IdItinerario: item.IdItinerario, SeccionEnviado: item.SeccionEnviado, Alumnos: []} :
                {IdSeccion: item.IdSeccion, IdItinerario: item.IdItinerario, Alumnos: []}
            index = matriculas.push(newSeccion) - 1
          }

          let indexAlumno = matriculas[index].Alumnos.findIndex(ma => ma.IdMatricula === item.IdMatricula)
          if (indexAlumno === -1) {
            let newAlumno = {
              IdMatricula: item.IdMatricula,
                TipoDoc: item.tipo_documento === 1 ? 'D.N.I.': 'CARNET DE EXTRANJERÍA',
              Doc: item.DNI,
              Alumno: item.Alumno,
              Sexo: item.Sexo === 'F' ? 'FEMENINO' : 'MASCULINO',
              Edad: this.calcularEdad(item.FechaNac),
              Cursos: []
            }
            indexAlumno = matriculas[index].Alumnos.push(newAlumno) - 1
          }
          if (self.dSearch.tipoActa === 'MA') {
            matriculas[index].Alumnos[indexAlumno].Cursos.push({
              IdNotaFinal: item.IdNotaFinal,
              Curso: item.Curso.toUpperCase(),
              Nota: null
            })
          } else if(['AR','AC','AE'].includes(self.dSearch.tipoActa) && item.EnviadoNotaMinedu === 0){
            matriculas[index].Alumnos[indexAlumno].Cursos.push({
              IdNotaFinal: item.IdNotaFinal,
              Curso: item.Curso.toUpperCase(),
              Nota: item.PromedioFinal
            })
          }
        })

        this.dItemsAlumno = matriculas
      } catch (error) {
        console.log(error)
        Swal.fire('¡ ERROR !', 'Error de conexión.', 'error')
      } finally {
        this.dTable.loading = false
      }
    }
  }
}
</script>